import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import AudioStreamer from 'components/shared/AudioStreamer';
import useStores from 'hooks/use-store';
import ContentWrapper from './Styles';
import { LaneContext } from '../../LaneWrapper';

const Player = ({ auctionLane, auctionId }) => {
  const [isPaused, setIsPaused] = useState(false);
  const { laneID } = useContext(LaneContext);
  const {
    AuctionStore: { openLanes },
    UIStore: {handleSetLaneAudio, audioLane, audioAuction},
  } = useStores(auctionId);

  const {
    mediaRoomID, audioVideoUrl, mediaToken, audioPlaying, audioPaused,
  } = auctionLane;

  /**
   * By default, if have an open lane we auto start the audio.
   * If the user previously paused the audio, we disable autostart on that lane.
   *
   */
  useEffect(() => {
    setTimeout(() => {
      if (openLanes.length && laneID === openLanes[0] && !audioPlaying && !audioPaused) {
        handleSetLaneAudio(auctionId, openLanes[0], !audioPlaying, false);
      }
    }, 3500);
    // eslint-disable-next-line
  }, [openLanes.length]);

  useEffect(() => {
    if (audioAuction === auctionId && !audioPlaying) {
      setIsPaused(true);
      return;
    }

    if ((audioAuction !== auctionId) || audioLane !== laneID) {
      setIsPaused(true);
    }

    if ((audioAuction === auctionId) && audioLane === laneID && audioPlaying) {
      setIsPaused(!audioPlaying);
      return;
    }

    if ((audioAuction === auctionId) && !audioPlaying && audioLane !== laneID) {
      setIsPaused(true);
    }
  }, [audioAuction, audioPlaying, audioLane])

  if (!auctionLane) {
    return null;
  }

  return (
    <ContentWrapper>
      <AudioStreamer
        auctionId={auctionId}
        mediaRoomID={mediaRoomID}
        audioVideoUrl={audioVideoUrl}
        mediaToken={mediaToken}
        laneID={laneID}
        setAudioState={handleSetLaneAudio}
        audioPlaying={!isPaused}
      />
    </ContentWrapper>
  );
};

Player.propTypes = {
  auctionLane: PropTypes.object,
};

Player.defaultProps = {
  auctionLane: null,
};

export default observer(Player);
